import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../../../../assets/styles/customer/CustomerRegister.css";
import axios from "axios";
import Swal from "sweetalert2";
import AppContext from "../../../../context/AppContext";

/* =============================================
   DATA
   ============================================= */
const CITIES = [
  "Lahore",
  "Karachi",
  "Islamabad",
  "Rawalpindi",
  "Faisalabad",
  "Multan",
  "Peshawar",
  "Quetta",
];

const AREAS = [
  "Lahore",
  "Karachi",
  "Islamabad",
  "Rawalpindi",
  "Faisalabad",
  "Multan",
  "Peshawar",
  "Quetta",
];

/* =============================================
   MAIN COMPONENT
   ============================================= */
const CustomerRegister = () => {
  const navigate = useNavigate();

  // Local States (jaise aapne Step1 mein likhi thi)
  const [showPw, setShowPw] = useState(false);
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [password, setPassword] = useState("");
  const [cityId, setCityId] = useState("");
  const [areaId, setAreaId] = useState("");
  // const baseUrl = "http://127.0.0.1:8000/api";
  const { baseUrl } = useContext(AppContext);

  useEffect(() => {
    const customerPhone = localStorage.getItem("customerPhone");
    const customerPassword = localStorage.getItem("customerPassword");
    if (customerPhone != null && customerPassword != null) {
      // navigate("/customer/dashboard");
      autoLogin(customerPhone, customerPassword);
    }
  }, []);

  const autoLogin = (customerPhone, customerPassword) => {
    const formData = new FormData();
    formData.append("phonenumber", customerPhone);
    formData.append("password", customerPassword);
    axios
      .post(
        // "http://127.0.0.1:8000/api/customer/auth/logincustomer",
        `${baseUrl}/customer/auth/loginCustomer`,
        formData,
        {
          "Content-type": "multipart-formdata",
        },
      )
      .then((response) => {
        if (response.data.success === true) {
          console.log(response.data);
          navigate("/customer/dashboard");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const customerSignup = () => {
    console.log("add customer function called");
    console.log(fullName, email, password, phoneNumber, cityId, areaId);

    const formData = new FormData();
    formData.append("fullName", fullName);
    // formData.append("email", email);
    formData.append("password", password);
    formData.append("phonenumber", phoneNumber);
    // formData.append("city_id",cityId);
    formData.append("city_id", 1);
    // formData.append("area_id",areaId);
    formData.append("area_id", 1);
    axios
      .post(`${baseUrl}/customer/auth/createCustomer`, formData, {
        "Content-type": "multipart-formdata",
      })
      .then((response) => {
        // if (response.data.success === true) {
        if (response.data) {
          // console.log("Admin has been created successfuly");
          console.log(response.data.message);
          console.log(response.data);
          Swal.fire({
            title: "Congratulations!",
            text: "Your account has been created successfuly",
            icon: "success",
            confirmButtonText: "Cool",
          });
          localStorage.setItem("customerPhone", phoneNumber);
          localStorage.setItem("customerPassword", password);
          navigate("/customer/dashboard");
        } else {
          Swal.fire({
            title: "Oops!",
            text: "Cannot create account at the moment",
            icon: "error",
            confirmButtonText: "Try Again",
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  // const CustomerRegister = () => {
  //   const navigate = useNavigate();
  //   const [form, setForm] = useState({
  //     fullName: '', phone: '', password: '', city: '', area: '',
  //   });
  //   const [error,   setError]   = useState('');
  const [loading, setLoading] = useState(false);

  //   const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  //   const handleSubmit = () => {
  //     setError('');
  //     const { fullName, phone, password, city, area } = form;
  //     if (!fullName || !phone || !password || !city || !area) {
  //       setError('Please fill in all fields.'); return;
  //     }
  //     if (password.length < 6) {
  //       setError('Password must be at least 6 characters.'); return;
  //     }
  //     setLoading(true);
  //     setTimeout(() => {
  //       setLoading(false);
  //       navigate('/customer/dashboard');
  //     }, 1200);
  //   };

  //   const handleKey = (e) => { if (e.key === 'Enter') handleSubmit(); };

  return (
    <div className="creg-bg">
      <div className="creg-card">
        {/* Logo */}
        <div className="creg-logo-wrap">
          <div className="creg-logo">
            <i className="bi bi-droplet-fill" />
          </div>
        </div>

        <h1 className="creg-title">Create Account</h1>
        <p className="creg-subtitle">Join MilkyWay as a customer</p>

        {/* Full Name */}
        <div className="creg-form-group">
          <label className="creg-label">Full Name</label>
          <div className="creg-input-wrap">
            <i className="bi bi-person creg-input-icon" />
            <input
              className="creg-input"
              placeholder="Enter your name"
              value={fullName}
              onChange={(e) => setFullName(e.target.value)}
              // onKeyDown={handleKey}
            />
          </div>
        </div>

        {/* Phone */}
        <div className="creg-form-group">
          <label className="creg-label">Phone Number</label>
          <div className="creg-input-wrap">
            <i className="bi bi-telephone creg-input-icon" />
            <input
              className="creg-input"
              placeholder="03001234567"
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
              // onKeyDown={handleKey}
            />
          </div>
        </div>

        {/* Password */}
        <div className="creg-form-group">
          <label className="creg-label">Password</label>
          <div className="creg-input-wrap">
            <i className="bi bi-lock creg-input-icon" />
            <input
              className="creg-input"
              type="password"
              placeholder="Create a password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              // onKeyDown={handleKey}
            />
          </div>
        </div>

        {/* City */}
        <div className="creg-form-group">
          <label className="creg-label">City</label>
          <div className="creg-input-wrap">
            <i className="bi bi-geo-alt creg-input-icon" />
            <select
              className="creg-input creg-input--select"
              value={cityId}
              onChange={(e) => setCityId(e.target.value)}
            >
              <option value="">Select City</option>
              <option>Lahore</option>
              <option>Karachi</option>
              <option>Islamabad</option>
              <option>Faisalabad</option>
              <option>Rawalpindi</option>
              <option>Gujranwala</option>
              <option>Multan</option>
            </select>
          </div>
        </div>

        {/* Area */}
        <div className="creg-form-group">
          <label className="creg-label">Area</label>
          <div className="creg-input-wrap">
            <i className="bi bi-geo-alt creg-input-icon" />
            <select
              className="creg-input creg-input--select"
              value={areaId}
              onChange={(e) => setAreaId(e.target.value)}
            >
              <option value="">Select Area</option>
              <option>DHA</option>
              <option>Gulberg</option>
              <option>Model Town</option>
              <option>Johar Town</option>
              <option>Bahria Town</option>
            </select>
          </div>
        </div>

        {/* {error && <p className="creg-error">{error}</p>} */}

        <button
          className="creg-submit-btn"
          onClick={customerSignup}
          disabled={loading}
        >
          {loading ? "Creating Account..." : "Create Account"}
        </button>

        <p className="creg-login-link">
          Already have an account?{" "}
          <button
            className="creg-link-btn"
            onClick={() => navigate("/customer/login")}
          >
            Login
          </button>
        </p>
      </div>
    </div>
  );
};

export default CustomerRegister;
